/* import __COLOCATED_TEMPLATE__ from './access-token-display.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

interface Signature {
  Args: {
    accessToken: string;
    inlineBlock?: boolean;
  };
  Element: HTMLElement;
}

export default class AccessTokenDisplay extends Component<Signature> {
  @service declare developerHub: $TSFixMe;

  get appPackage() {
    return this.developerHub.appPackage;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'DeveloperHub::AppPackage::Oauth::AccessToken::AccessTokenDisplay': typeof AccessTokenDisplay;
    'developer-hub/app-package/oauth/access-token/access-token-display': typeof AccessTokenDisplay;
  }
}
